import client from 'services/client'

export const getRelations = async () => {
  try {
    const { data }: any = await client.get('relations')

    return data
  } catch (error: any) {
    throw new Error(
      error?.response?.data?.message || error?.message || 'Erro desconhecido'
    )
  }
}
